import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'fall_protection_equipment_maintenance_logs_are_not_kept'

export const dataPointDefinition = {
  retracedId: 'fall_protection_equipment_maintenance_logs_are_not_kept',
  name: 'Fall protection equipment maintenance logs are not kept',
  description: 'Fall protection equipment should be regularly inspected and logs should be maintained',
  meta: {
    slcpMeta: {
      key: 'hs-bui-32x',
      number: 'HS-BUI-7-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-29',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-32x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29610,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
